(function () {
  function formatEUR(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  function updateBar(bar, total) {
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    var remaining = threshold - total;
    var reached = remaining <= 0;
    var percent = threshold > 0 ? Math.min(100, Math.round((total * 100) / threshold)) : 0;

    bar.classList.toggle('veizu-freeship--reached', reached);

    var fill = bar.querySelector('[data-freeship-fill]');
    if (fill) fill.style.width = percent + '%';

    var text = bar.querySelector('[data-freeship-text]');
    if (text) {
      var html = reached
        ? 'Geschafft – dein Versand ist kostenlos!'
        : 'Noch <strong>' + formatEUR(remaining) + '</strong> bis zum kostenlosen Versand';
      // Nur schreiben, wenn sich etwas geändert hat. Sonst löst jede
      // Aktualisierung im Popup den Beobachter unten erneut aus (Endlosschleife).
      if (text.innerHTML !== html) text.innerHTML = html;
    }
  }

  function refreshAll() {
    var bars = document.querySelectorAll('[data-veizu-freeship]');
    if (!bars.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bars.forEach(function (b) { updateBar(b, cart.total_price); });
      })
      .catch(function () {});
  }

  function init() {
    refreshAll();

    var notification = document.getElementById('cart-notification') ||
      document.querySelector('cart-notification');
    if (!notification) return;

    // Nur das Auf- und Zuklappen des Popups beobachten (Klassenwechsel am
    // Element selbst), nicht dessen Inhalt: der Balken sitzt selbst im Popup.
    var wasActive = notification.classList.contains('active');
    var observer = new MutationObserver(function () {
      var isActive = notification.classList.contains('active');
      if (isActive && !wasActive) refreshAll();
      wasActive = isActive;
    });
    observer.observe(notification, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
